import FeatureFlagsContainer from './FeatureFlagsContainer'

export default function FeatureFlagsScreen() {
    return <FeatureFlagsContainer />
}
